import { jsx } from "react/jsx-runtime";
import React from "react";
var checkmark_default = (prefix = "") => {
  return [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5773 13.5047 16.55 7.5l1.418 1.4104-7.3907 7.4303L6 11.7389l1.418-1.4105 3.1593 3.1763z"
      }
    )
  ];
};
export {
  checkmark_default as default
};
